import { SquareRowCollection } from '@/molecules/SquareRowCollection/SquareRowCollection'
import { LinkViewModel } from '@/services/RenderService'
import { useTranslate } from '@/utils/translate/translate-client'

interface AlbumSectionProps {
  soundtracks: LinkViewModel[]
}

export const AlbumSection: React.FC<AlbumSectionProps> = ({ soundtracks }) => {
  const { t } = useTranslate('music')

  return (
    <section className="core-gray-950 relative w-full py-[72px]">
      <SquareRowCollection title={t('soundtracks', 'Soundtracks')} contentLinks={soundtracks} padding />
    </section>
  )
}
